module.exports = __webpack_public_path__ + "img/15.e154305.png";